import { render } from "./Uploading.vue?vue&type=template&id=c3da945c"
import script from "./Uploading.vue?vue&type=script&lang=js"
export * from "./Uploading.vue?vue&type=script&lang=js"

import "./Uploading.vue?vue&type=style&index=0&id=c3da945c&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__